import React from 'react';
import styled from 'styled-components';
import breakPoints, { forDesktop } from '@westwing/ui-kit/breakPoints';
import BellaHybridLink from 'Client/components/Generic/Links/BellaHybridLink';
import { FooterLinks } from 'OneWestwingFooter/types';
import { FooterTitleDesktop } from '../common/FooterTitleDesktop';
import ErrorBoundary from 'Client/components/Generic/ErrorBoundaries';

const DesktopComponentWrapper = styled.div`
    display: none;

    ${forDesktop`
        display: flex;
        justify-content: center;
    `}
`;

const DesktopComponent = styled.div`
    width: 100%;
    max-width: ${breakPoints.breakpointWideScreens};
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

const FooterLinkWrapper = styled.ul`
    display: flex;
    flex-wrap: wrap;
    padding-inline-start: 0;
    max-width: 300px;
`;

const FooterLink = styled.li`
    margin-bottom: 8px;
    margin-right: 8px;
    box-sizing: border-box;
`;

const StyledFooterLink = styled(BellaHybridLink)`
    display: block;
    text-decoration: none;
    box-sizing: border-box;
`;

const DefaultDesktopWrapper = styled.nav`
    width: 25%;
`;

const FooterPartnersLinksDesktop = ({
    track,
    footerLinks,
}: {
    track: (trackingAction?: string) => void;
    footerLinks: FooterLinks[];
}) => (
    <DesktopComponentWrapper>
        <DesktopComponent>
            {footerLinks.map(linksColumn => (
                <DefaultDesktopWrapper key={linksColumn.key}>
                    <ErrorBoundary boundaryName={linksColumn.key} fallbackComponent={null}>
                        <FooterTitleDesktop $hidden={!linksColumn.items?.[0].content} aria-hidden>
                            {linksColumn.title}
                        </FooterTitleDesktop>
                        <FooterLinkWrapper aria-label={linksColumn.title}>
                            {linksColumn.items.map((item, itemIndex) => (
                                <FooterLink key={`footer_${item.to ?? `${linksColumn.title}_${itemIndex}`}`}>
                                    {item.to ? (
                                        <StyledFooterLink
                                            target={item.openInNewTab ? '_blank' : '_self'}
                                            to={item.to}
                                            onClick={() => track(item.trackingAction)}
                                        >
                                            {item.content}
                                        </StyledFooterLink>
                                    ) : (
                                        // In this case tracking will not happen
                                        item.content
                                    )}
                                </FooterLink>
                            ))}
                        </FooterLinkWrapper>
                    </ErrorBoundary>
                </DefaultDesktopWrapper>
            ))}
        </DesktopComponent>
    </DesktopComponentWrapper>
);

export default FooterPartnersLinksDesktop;
